export const returnPOCUserObject = (user) => {
    return({
        pocid: user.pocid,
        isPOCUser: true,
        memberID: user.member_ID,
        sfid: user.sfid,
        userID: user.userID,
        passwordIsTemporary: user.passwordIsTemporary,
        securityQuestionsComplete: user.securityQuestionsComplete
    })
}